import { render } from "./FormaPagamentoTiposPagamento.vue?vue&type=template&id=4f1628d5&scoped=true&ts=true"
import script from "./FormaPagamentoTiposPagamento.vue?vue&type=script&lang=ts"
export * from "./FormaPagamentoTiposPagamento.vue?vue&type=script&lang=ts"

import "./FormaPagamentoTiposPagamento.vue?vue&type=style&index=0&id=4f1628d5&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1628d5"]])

export default __exports__